import { emperor } from '~/services';

export const uploadBranchData = async (formData: FormData) => {

  
  // Log FormData contents in a way that's compatible with the current TypeScript target
  const entries = Array.from(formData.entries());
  entries.forEach(([key, value]) => {
    if (value instanceof File) {
      console.log(`Key: ${key}, File: ${value.name}, Size: ${value.size}, Type: ${value.type}`);
    } else {
      console.log(`Key: ${key}, Value: ${value}`);
    }
  });
  
  
  try {
    // The backend expects the file to be named 'csvFile' based on the inputs definition
    // Rename the file field from 'file' to 'csvFile' if needed
    const fileEntry = entries.find(([key]) => key === 'file');
    if (fileEntry && fileEntry[1] instanceof File) {
      // Create a new FormData with the correct field name
      const newFormData = new FormData();
      newFormData.append('csvFile', fileEntry[1]);
      
      // Add any other fields from the original FormData
      entries.forEach(([key, value]) => {
        if (key !== 'file') {
          newFormData.append(key, value);
        }
      });
      
      // Use the new FormData with the correct field name
      const response = await emperor.post('/branch-data/upload', newFormData);
      return response;
    } else {
      // If no file was found, use the original FormData
      const response = await emperor.post('/branch-data/upload', formData);
      return response;
    }
  } catch (error) {
    console.error("API call error:", error);
    throw error;
  }
}; 